/* eslint-disable @typescript-eslint/no-loss-of-precision */
/* eslint-disable no-useless-escape */
import bigInt from 'big-integer';

import { comma } from '@utils/utils';

/** 금액 최대값 9,999조 */
export const MAX_AMOUNT = '9999999999999999';

/** 로그인 ID 유효성 체크 */
export const loginIdValidateOptions = {
  required: '5글자 이상 입력해 주세요.',
  maxLength: {
    value: 20,
    message: '아이디는 20글자를 넘을 수 없습니다.',
  },
};

/** 디비전ID 유효성 체크 */
export const divisionValidateOptions = {
  required: '회사코드를 입력해 주세요.',
  minLength: {
    value: 2,
    message: '최소 2자 이상 입력해 주세요.',
  },
  maxLength: {
    value: 10,
    message: '최대 10자리까지 입력할 수 있습니다.',
  },
};

// 이메일 유효성 체크
export const emailValidateOptions = {
  required: '이메일을 입력해 주세요.',
  maxLength: {
    value: 60,
    message: '최대 30자까지 입력할 수 있습니다.',
  },
  pattern: {
    value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/,
    message: '이메일 형식을 확인해주세요.',
  },
};

// 비밀번호 유효성 체크
export const passwordValidateOptions = {
  required:
    '영문, 숫자, 특수문자 포함 8자리 이상, 30자리 이하로 입력해 주세요.',
  pattern: {
    value: /^(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,30}$/,
    message:
      '영문, 숫자, 특수문자 포함 8자리 이상, 30자리 이하로 입력해 주세요.',
  },
  minLength: {
    value: 8,
    message: '최소 8자리 이상 입력해 주세요.',
  },
  maxLength: {
    value: 30,
    message: '30자리 이하로 입력해 주세요.',
  },
};

export const phoneValidateOptions = {
  required: '연락처를 입력해 주세요.',
  // valueAsNumber: true,
  pattern: {
    value: /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/,
    message: '연락처 형식을 확인해주세요.',
  },
};

/** 전화번호 유효성 검사 (선택사항, 모든 문자 허용, 길이 제한 없음) */
export const phoneOptionalValidateOptions = {
  validate: (value: string | null | undefined) => {
    // 빈 값이면 통과 (null로 저장됨)
    if (!value || value.trim() === '') {
      return true;
    }

    // 모든 문자 허용, 길이 제한 없음
    return true;
  },
};

/** 이름 유효성 검사 (선택사항, 2-50자) */
export const nameOptionalValidateOptions = {
  validate: (value: string | null | undefined) => {
    // 빈 값이면 통과 (선택사항)
    if (!value || value.trim() === '') {
      return true;
    }
    // 2자 이상 50자 이하 검증
    const trimmedValue = value.trim();
    if (trimmedValue.length < 2) {
      return '이름은 최소 2자 이상 입력해 주세요.';
    }
    if (trimmedValue.length > 50) {
      return '이름은 최대 50자까지 입력할 수 있습니다.';
    }
    return true;
  },
};

export const nameValidateOptions = {
  required: '이름을 입력해 주세요.',
  minLength: {
    value: 2,
    message: '최소 2자이상 입력해 주세요.',
  },
  maxLength: {
    value: 15,
    message: '최대 15자까지 입력할 수 있습니다.',
  },
};

/** 회사명 입력 */
export const companyNameValidateOptions = {
  required: '사업명을 입력해 주세요.',
  minLength: {
    value: 1,
    message: '최소 1자이상 입력해 주세요.',
  },
  maxLength: {
    value: 50,
    message: '최대 50자까지 입력할 수 있습니다.',
  },
};

/** 대표자명 입력 */
export const companyCeoValidateOptions = {
  required: '대표자명을 입력해 주세요.',
  minLength: {
    value: 1,
    message: '최소 1자이상 입력해 주세요.',
  },
  maxLength: {
    value: 50,
    message: '최대 50자까지 입력할 수 있습니다.',
  },
};

/** 사업자번호 체크 */
export const bizNoValidateOptions = {
  required: '사업자번호를 입력해 주세요.',
  minLength: {
    value: 12,
    message: '사업자번호를 다시 확인해 주세요.',
  },
  maxLength: {
    value: 12,
    message: '사업자번호를 다시 확인해 주세요.',
  },
  pattern: {
    value: /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})/,
    message: '사업자번호를 다시 확인해 주세요.',
  },
};

/** 법인번호 체크 */
export const corporateNoValidateOptions = {
  required: '법인번호를 입력해 주세요.',
  minLength: {
    value: 14,
    message: '법인번호를 다시 확인해 주세요.',
  },
  maxLength: {
    value: 14,
    message: '법인번호를 다시 확인해 주세요.',
  },
  pattern: {
    value: /^^(\d{6,6})+[-]+(\d{7,7})/,
    message: '법인번호를 다시 확인해 주세요.',
  },
};

/** 주소 체크 */
export const addressValidateOptions = {
  required: '주소를 입력해 주세요.',
  maxLength: {
    value: 500,
    message: '최대 500자까지 입력할 수 있습니다.',
  },
};

/** 날짜 체크 */
export const dateValidateOptions = {
  required: '날짜를 입력해 주세요.',
  patter: {
    value: /^^(\d{4,4})+[-]+(\d{2,2})+[-]+(\d{2,2})/,
    message: '날짜 형식을 확인해 주세요.',
  },
};

/** 날짜체크 (Optional) */
export const dateValidateOptionsNoRequired = {
  patter: {
    value: /^^(\d{4,4})+[-]+(\d{2,2})+[-]+(\d{2,2})/,
    message: '날쩌 형식을 확인해 주세요.',
  },
};

/** 금액 체크 */
export const amountValidateOptions = {
  required: '금액을 입력해 주세요.',
  minLength: {
    value: 2,
    message: '최소 10이상 입력해 주세요.',
  },
  maxLength: {
    value: 20,
    message: '입력가능한 최대금액을 초과하였습니다.',
  },
};

/** 수량 체크 */
export const quantityValidateOptions = {
  required: '수량을 입력해 주세요.',
  minLength: {
    value: 2,
    message: '최소 10이상 입력해 주세요.',
  },
  maxLength: {
    value: 20,
    message: '입력가능한 최대수량을 초과하였습니다.',
  },
};

/** 조합구분 체크 */
export const fundTypeValidationOptions = {
  required: '조합구분값을 선택해 주세요.',
};

/** 조합상태 체크 */
export const fundStatusValidationOptions = {
  required: '조합상태값을 선택해 주세요.',
};

/** 기업검색 (혁숲 데이터) */
export const companySearchValidationOptions = {
  required: '기업명을 입력해 주세요.',
  minLength: {
    value: 1,
    message: '최소 1글자 이상 입력해 주세요.',
  },
  maxLength: {
    value: 14,
    message: '최대 14글자까지 입력할 수 있습니다.',
  },
};

/** 주식종류 체크 */
export const stockTypeValidationOptions = {
  required: '주식종류를 선택해 주세요.',
};

/** 주식발행종류 체크 */
export const stockIssuanceTypeValidationOptions = {
  required: '유형을 선택해 주세요.',
};

/**
 * ========================================================================================================
 * ========================================================================================================
 */

/** 사업유형 체크 */
export const groupTypeValidationOptions = {
  required: '사업유형을 선택해 주세요.',
};

/** 사업 운영상태 체크 */
export const groupStatusValidationOptions = {
  required: '운영상태를 선택해 주세요.',
};

/** 계정권한상태 체크 */
export const accountRoleValidationOptions = {
  required: '계정권한을 선택해 주세요.',
};

/** 공지사항 제목 체크 */
export const noticeTitleValidationOptions = {
  required: '제목을 입력해 주세요.',
  maxLength: {
    value: 200,
    message: '최대 200글자까지 입력할 수 있습니다.',
  },
};

/** 공지사항 내용 체크 */
export const noticeContentValidationOptions = {
  required: '내용을 입력해 주세요.',
  maxLength: {
    value: 1000,
    message: '최대 1,000글자까지 입력할 수 있습니다.',
  },
};

/** 메모 내용 체크 */
export const memoValidationOptions = {
  required: true,
  maxLength: {
    value: 500,
    message: '',
  },
};

/** 입주장소 체크 */
export const placeValidationOptions = {
  maxLength: {
    value: 100,
    message: '최대 100글자까지 입력할 수 있습니다.',
  },
};

/** 리포트 제목 체크 */
export const reportTitleValidationOptions = {
  required: '제목을 입력해 주세요.',
  maxLength: {
    value: 100,
    message: '최대 100글자까지 입력할 수 있습니다.',
  },
};

/** 리포트 컨텐츠 체크 */
export const reportContentsValidationOptions = {
  required: true,
  maxLength: {
    value: 1000,
    message: '',
  },
};

/** 산업 등록 > 산업명 체크 */
export const industryNameValidationOptions = {
  required: '산업명을 입력해 주세요.',
  maxLength: {
    value: 100,
    message: '최대 100글자까지 입력할 수 있습니다.',
  },
};

/** Mapping ID 체크 */
export const mappingIdValidationOptions = {
  required: true,
  minLength: {
    value: 10,
    message: '기업ID를 다시 확인해 주세요.',
  },
  maxLength: {
    value: 10,
    message: '기업ID를 다시 확인해 주세요.',
  },
};

/** 금액입력 Validation */
export const newAmountValidateOptions = (
  minimum: string,
  maximum: string,
  isRequired?: string
) => {
  return {
    required: isRequired ? isRequired : false,
    validate: {
      min: (value: any) =>
        Number(value.replaceAll(',', '')) >= Number(minimum) ||
        `최소 ${comma(minimum)} 이상 입력해야 합니다.`,
      max: (value: any) =>
        bigInt(maximum).greaterOrEquals(value.replaceAll(',', '')) ||
        `최대 ${comma(maximum)}까지 입력 가능합니다.`,
    },
  };
};

/** 음수 허용 금액/수량 입력 Validation (절댓값 기준 max 검사) */
export const newSignedAmountValidateOptions = (
  absMax: string,
  isRequired?: string
) => {
  return {
    required: isRequired ? isRequired : false,
    validate: {
      numeric: (value: any) => {
        const raw = String(value ?? '').replaceAll(',', '');
        return raw === '' || /^-?\d+$/.test(raw) || '숫자만 입력해 주세요.';
      },
      notDashOnly: (value: any) => {
        const raw = String(value ?? '').replaceAll(',', '');
        return raw === '' || raw !== '-' || '숫자를 입력해 주세요.';
      },
      max: (value: any) => {
        const raw = String(value ?? '')
          .replaceAll(',', '')
          .replace(/^-/, '');
        if (raw === '' || raw === '-') return true;
        return (
          bigInt(absMax).greaterOrEquals(raw) ||
          `최대 ${comma(absMax)}까지 입력 가능합니다.`
        );
      },
    },
  };
};
